module.exports = __webpack_public_path__ + "spsa logo (1).39af291.png";